<template lang="pug">
    v-container(fluid grid-list-md)
        v-overlay(:value="loading || subChannelLoading || deleting")
            v-progress-circular(indeterminate size="64")
        edit-dialog(ref="refEditDialog" @saved="onSaved")
        v-layout(wrap)
            v-flex(xs12)
                page-title(:title="$t('pages.settings.channel.title')" :icon="pageIcons.chat").mb-2

            v-flex(xs12)
                v-data-table(:headers="headers" :items="items" :mobile-breakpoint="50" single-select :show-select="false" id="table"
                    v-model="selectedRows" item-key="id"
                    @click:row="onClickRow"
                    :footer-props="{ showFirstLastPage: true, showCurrentPage: true }" @update:options="onChangeOptions"
                    :loading="loading" :options.sync="options" :server-items-length="total" multi-sort).elevation-3

            v-flex(xs12 :align-self-start="!selectedRow")
                v-layout(column align-center v-if="!selectedRow" mt-3)
                    v-icon(size="100" color="grey") {{pageIcons.chat}}
                    .title.grey--text Please Select Channel First :)
                v-data-table(v-else :headers="subChannelHeaders" :items="subChannels" :mobile-breakpoint="50"
                    :footer-props="{ showFirstLastPage: true, showCurrentPage: true }" :options.sync="subChannelOptions").elevation-3
                    template(#item.action='{ item }')
                        v-layout(pa-0 ma-0 justify-center)
                            v-btn(icon @click='editItem(item)')
                                v-icon mdi-pencil-outline
                            v-btn(icon @click='deleteItem(item)')
                                v-icon mdi-delete-outline
                    template(#item.chat="{value}")
                        v-chip(:color="value ? 'green' : 'red'" dark small)
                            v-icon(small) {{value ? 'mdi-check' : 'mdi-cancel'}}
                    template(#top)
                        v-layout(ma-0 pa-2 align-baseline)
                            .title {{selectedRow.title}}
                            .caption.grey--text.hidden-xs-only &nbsp; - (Sub Channel)
                            v-spacer
                            v-btn(color="primary" :rounded="false" :disabled="false" @click="newItem")
                                v-icon(left dark) mdi-plus-circle-outline
                                span {{$t('pages.settings.channel.buttonAdd')}}
</template>

<script>
import { sync, get, call } from "vuex-pathify";
import general from "../../mixins/general";
import PageTitle from "../../components/commons/PageTitle";
import EditDialog from "../../components/channel/EditDialog";
import crud from "../../mixins/crud";
import auth from "../../mixins/auth";

export default {
  name: "ChannelSetting",
  components: { PageTitle, EditDialog },
  mixins: [general, crud, auth],
  computed: {
    selectedRows: sync("channels/selectedRows"),
    options: sync("channels/options"),
    subChannelOptions: sync("channels/subChannelOptions"),
    loading: get("channels/loading"),
    // loaded: get("channels/loaded"),
    items: get("channels/items"),
    total: get("channels/total"),
    subChannels: get("channels/subChannels"),
    selectedRow: get("channels/selectedRow"),
    subChannelLoading: get("channels/subChannelLoading"),

    headers: {
      get() {
        return [
          {
            text: this.$t("pages.settings.channel.table.headers.title.title"),
            value: "title",
            sortable: true,
            class: ["body-2"]
          },
          {
            text: this.$t(
              "pages.settings.channel.table.headers.companies_count.title"
            ),
            align: "center",
            sortable: false,
            value: "companies_count",
            class: ["body-2"]
          },
          {
            text: this.$t(
              "pages.settings.channel.table.headers.users_count.title"
            ),
            align: "center",
            sortable: false,
            value: "users_count",
            class: ["body-2"]
          }
        ];
      }
    },
    subChannelHeaders: {
      get() {
        return [
          {
            text: this.$t(
              "pages.settings.channel.subChannelTable.headers.title.title"
            ),
            value: "title",
            sortable: true,
            class: ["body-2"]
          },
          {
            text: this.$t(
              "pages.settings.channel.subChannelTable.headers.chat.title"
            ),
            value: "chat",
            sortable: true,
            class: ["body-2"]
          },
          {
            text: this.$t(
              "pages.settings.channel.subChannelTable.headers.companies_count.title"
            ),
            align: "center",
            sortable: false,
            value: "companies_count",
            class: ["body-2"]
          },
          {
            text: this.$t(
              "pages.settings.channel.subChannelTable.headers.users_count.title"
            ),
            align: "center",
            sortable: false,
            value: "users_count",
            class: ["body-2"]
          },
          {
            text: this.$t(
              "pages.settings.channel.subChannelTable.headers.actions.title"
            ),
            align: "center",
            value: "action",
            class: ["body-2"],
            sortable: false
          }
        ];
      }
    }
  },
  data() {
    return {
      loaded: false,
      deleting: false
    };
  },
  methods: {
    loadAll: call("channels/load"),
    loadSubChannel: call("channels/loadSubChannel"),
    reload: call("channels/reload"),
    updateOptions: call("channels/updateOptions"),
    toggleSort: call("channels/toggleSort"),

    onClickRow(value) {
      this.selectedRows = [value];
      this.$store.set("channels/selectedRow", value).then(() => {
        this.loadSubChannel(value.id);
      });
    },

    onChangeOptions(options) {
      if (this.loaded && !this.loading) {
        this.updateOptions(options);
      }
    },
    onRemoveKeywordChip() {
      if (!this.loading) {
        this.searchHandle("");
      }
    },
    onRemoveSortChip(column) {
      if (this.loaded && !this.loading) {
        this.removeColumnSorted(column);
      }
    },
    onToggleSort(column) {
      if (this.loaded && !this.loading) {
        this.toggleSort(column);
      }
    },
    async newItem() {
      this.$refs["refEditDialog"].show("create", this.selectedRow);
    },
    editItem(item) {
      this.$refs["refEditDialog"].show("edit", this.selectedRow, item);
    },
    deleteItem(item) {
      this.$confirm(
        this.$t("messages.deleteSubChannelConfirmation").printf(item)
      ).then(value => {
        if (value) {
          this.deleting = true;
          setTimeout(() => {
            this.axios
              .delete(`sub-channels/${item.id}`)
              .then(() => {
                this.deleting = false;
                this.$toasted.info(
                  this.$t("general.deleted") + ` "${item.title}"`,
                  { icon: "check" }
                );
                this.reload(undefined);
              })
              .catch(error => {
                this.deleting = false;
                this.deleteErrorHandler(error).then(() => this.reload());
              });
          }, 500);
        }
      });
    },
    onSaved(channel) {
      this.$toasted.success(this.$t("general.saved") + ` "${channel.title}"`, {
        icon: "check"
      });
      this.reload(undefined);
    }
  },
  mounted() {
    if (!this.loading) {
      this.loadAll({ options: this.options }).then(() => {
        // if (this.selectedRow) {
        //     this.selectedRows = [this.selectedRow];
        // }
        // this.afterLoad(items);
        this.loaded = true;
      });
    } else {
      this.loaded = true;
    }
  }
};
</script>

<style scoped></style>
